import axiosInstance from '../../core/axiosConfig';

export interface DeliveryCoordinates {
  lat: number;
  lon: number;
}

export interface DeliveryFeeRequest {
  pickup: {
    location: {
      coordinates: DeliveryCoordinates;
    };
  };
  dropoff: {
    location: {
      coordinates: DeliveryCoordinates;
    };
  };
}

export interface DeliveryFeeResponse {
  amount: number;
  currency: string;
  estimatedDeliveryTime: number;
}

export class DeliveryService {
  getDeliveryFee = async (request: DeliveryFeeRequest): Promise<DeliveryFeeResponse> => {
    const response = await axiosInstance.post<DeliveryFeeResponse>(
      '/admin/get/delivery/fee',
      request,
    );
    return response.data;
  };
}
